import type {
	BeneficiaryPayload,
	ComputedBeneficiaryPayload,
} from '@Application/Beneficiaries/Beneficiaries/Actions/beneficiaryFetched';
import computeBeneficiaryPayload from '@Application/Beneficiaries/Beneficiaries/Actions/computeBeneficiaryPayload';

export type BeneficiaryUpdatedAction = {
	type: 'BENEFICIARY_UPDATED';
	payload: ComputedBeneficiaryPayload;
	facilityId: number;
};

export default (payload: BeneficiaryPayload, facilityId: number): BeneficiaryUpdatedAction => ({
	type: 'BENEFICIARY_UPDATED',
	payload: computeBeneficiaryPayload(payload),
	facilityId,
});
